import React from 'react';



const AssignedMe = () => {
    return (
        <div>

            <h1>AssignedMe</h1>
        </div>
    );
}

export default AssignedMe;
